export function haldane(p0: number, pInspired: number, k: number, t: number): number {
  return p0 + (pInspired - p0) * (1 - Math.exp(-k * t));
}
